<template>
  <v-form>
    <SelectItems
      v-model="formData.user_groups"
      :field-key="fieldKey('user_groups')"
      :label="$t('UserGroup.UserGroups')"
      get-items-api="user-groups/"
      item-text="user_group_name"
      item-value="id"
    />
    <!-- buttons -->
    <v-row
      style="margin-top: -30px;"
      class="justify-end flex-wrap"
    >
      <ActionButton
        :label="$t('UserList.ChangeToSelectGroups')"
        class="mt-3 ma-2 pa-2"
        @click="submit('change_users_to_groups')"
      />
      <ActionButton
        :label="$t('UserList.AddToSelectGroups')"
        class="mt-3 ma-2 pa-2"
        @click="submit('add_users_to_groups')"
      />
      <ActionButton
        :label="$t('UserList.RemoveToSelectGroups')"
        class="mt-3 ma-2 pa-2"
        @click="submit('remove_users_to_groups')"
      />
    </v-row>
  </v-form>
</template>

<script>
  import FormMixin from './FormMixin'
  import SelectItems from '@/components/parts/inputs/SelectItems'
  import ActionButton from '@/components/parts/button/ActionButton'

  export default {
    components: {
      ActionButton,
      SelectItems
    },
    mixins: [FormMixin],
    props: {
      selectUsers: {
        type: Array,
        default () {
          return []
        }
      }
    },
    emits: ['reload'],
    data: () => ({
      formData: {
        user_groups: []
      }
    }),
    methods: {
      submit (action) {
        let formData = {
          user_groups: this.convertList(this.formData.user_groups),
          users: this.convertList(this.selectUsers)
        }
        this.$http.post(`/user-groups/${action}/`, formData).then((res) => {
          this.$emit('reload')
        })
      },
      /**
       * convert object to array
       * @param target an object
       * @return {array} converted array
       */
      convertList (target) {
        let ret = []
        for (let k of Object.keys(target)) {
          ret.push(target[k])
        }
        return ret
      }
    }
  }
</script>
